import { IShareCapabilities, probeFile, responseToFile } from './share';

/**
 * True when the browser can share actual files — the only path that offers «Save
 * Video» (to Photos) and direct sharing to WhatsApp/Telegram on iOS. `navigator.share`
 * alone exists on more browsers but can't carry the mp4, so probe files support with a
 * dummy File. Used to gate the click interception before we commit to a fetch.
 */
export function supportsFileShare(nav: Navigator = navigator): boolean {
    if (!nav || typeof nav.canShare !== 'function') {
        return false;
    }
    try {
        return nav.canShare({ files: [probeFile()] });
    } catch {
        return false;
    }
}

// Fetch the mp4 and hand the response to responseToFile() (tested). `credentials:
// 'omit'` keeps it a simple, cookie-less cross-origin request (the static host
// reflects our origin via CORS in download.php).
async function fetchFile(
    url: string,
    name: string,
    onProgress?: (ratio: number | null) => void
): Promise<File> {
    const res = await fetch(url, { credentials: 'omit' });
    return responseToFile(res, name, onProgress);
}

export function createBrowserShare(): IShareCapabilities {
    return {
        canShareFiles: (files) => {
            try {
                return (
                    typeof navigator.canShare === 'function' &&
                    navigator.canShare({ files })
                );
            } catch {
                return false;
            }
        },
        share: (files) => navigator.share({ files }),
        fetchFile,
    };
}
